export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-accent-500 text-sm font-medium tracking-wide uppercase mb-2">
            Why Choose Us
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            The Pandabuy Spreadsheet Difference
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70 transition-all duration-300 hover:border-foreground-300">
            <div className="w-14 h-14 rounded-xl bg-accent-100/50 flex items-center justify-center mb-5">
              <i className="ri-refresh-line text-2xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Daily Updated Lists</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Our pandabuyspreadsheet collections are refreshed every single day with new community-verified finds across all fourteen categories. Old links are removed and quality ratings stay current.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70 transition-all duration-300 hover:border-foreground-300">
            <div className="w-14 h-14 rounded-xl bg-secondary-100/50 flex items-center justify-center mb-5">
              <i className="ri-check-double-line text-2xl text-secondary-500"></i>
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Community Verified</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Every item in the spreadsheet has been reviewed and rated by real shoppers. Sizing notes, quality scores, and batch feedback come from actual buyers — not marketing copy.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70 transition-all duration-300 hover:border-foreground-300">
            <div className="w-14 h-14 rounded-xl bg-accent-100/50 flex items-center justify-center mb-5">
              <i className="ri-shield-check-line text-2xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">14 Curated Categories</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              From trending sneakers to hidden-gem accessories, our pandabuy spreadsheet covers every angle of fashion discovery. Jump between categories effortlessly in one organized view.
            </p>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-14">
          {[
            { value: "10,000+", label: "Curated Items" },
            { value: "14", label: "Categories" },
            { value: "Daily", label: "Update Cycle" },
            { value: "Free", label: "Forever" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-1">{stat.value}</p>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}